export default {
  "pl": {
    "integration": {
      "labels": {
        "create_failed": "Nie udało się utworzyć",
        "crm_id": "ID {integration_oid_type} w integracji {integration_name}: {integration_oid}",
        "error": "błąd",
        "last_sync_with": "Ostatnia synchronizacja z integracją {integration_name}: {last_sync_at}",
        "status": "status",
        "synced_at": "Ostatnia synchronizacja: ",
        "title": "Integracje",
        "update_failed": "nie udało się zaktualizować"
      },
      "record_actions": {
        "delete": "Aby trwale usunąć zapis {record_type} z platformy Ziggu, najpierw usuń zapis {record_type} <strong>z poziomu integracji {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integracja zaktualizowana"
      }
    }
  }
}
